import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function PricingCTA() {
  return <section id="pricing" className="py-24 px-4 bg-brand-bg" data-id="element-123">
      <div className="max-w-4xl mx-auto" data-id="element-124">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white rounded-3xl p-8 md:p-12 shadow-2xl shadow-stone-200/50 border border-stone-100 text-center relative overflow-hidden" data-id="element-125">
          <div className="absolute top-0 left-0 w-full h-2 bg-brand-accent" data-id="element-126"></div>

          <h2 className="text-4xl md:text-5xl mb-6 text-brand-dark max-w-2xl mx-auto" data-id="element-127">
            Recupera tu tranquilidad, tu tiempo y tu dinero hoy mismo.
          </h2>

          <p className="text-xl text-stone-600 mb-10 max-w-2xl mx-auto" data-id="element-128">
            El sistema completo "Cena en 15" está diseñado para pagarse solo en
            tu primera noche sin pedir delivery.
          </p>

          <div className="flex flex-col md:flex-row items-center justify-center gap-8 mb-10" data-id="element-129">
            <img src="https://cdn.magicpatterns.com/uploads/3gDiM7iqatHesZXQXZWcXW/ideogram-v3.0_a_surreal_and_vibrant_cinematic_photo_of_A_premium_digital_product_mockup_featur-0.jpg" alt="Cena en 15" className="w-48 h-auto rounded-xl shadow-lg rotate-[-2deg]" data-id="element-130" />

            <div className="text-center md:text-left" data-id="element-131">
              <div className="inline-block bg-brand-red text-white font-bold text-sm px-3 py-1 rounded-full mb-3 uppercase tracking-wider" data-id="element-132">
                🔥 Oferta de Lanzamiento — 67% OFF
              </div>
              <div className="flex items-baseline justify-center md:justify-start gap-3 mb-1" data-id="element-133">
                <span className="text-3xl text-stone-400 line-through font-medium tracking-tight" data-id="element-134">
                  $19.00
                </span>
              </div>
              <div className="flex items-baseline justify-center md:justify-start gap-2 mb-2" data-id="element-135">
                <span className="text-6xl font-black text-brand-accent tracking-tighter" data-id="element-136">
                  $6.39
                </span>
                <span className="text-xl text-stone-500 font-medium" data-id="element-137">USD</span>
              </div>
              <div className="text-brand-green font-medium flex items-center justify-center md:justify-start gap-1.5" data-id="element-138">
                <ShieldCheckIcon className="w-5 h-5" data-id="element-139" /> Pago único, acceso de
                por vida
              </div>
            </div>
          </div>

          <motion.a id="buy-now" href="https://cuidatuscenas.com/cart/51348841365728:1" target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="inline-block w-full md:w-auto bg-brand-accent hover:bg-brand-accent-hover text-white font-bold text-xl py-5 px-10 rounded-2xl shadow-xl shadow-brand-accent/30 transition-all animate-pulse-slow text-center" data-id="element-140">
            ¡SÍ, QUIERO CENAR EN 15 MINUTOS!
          </motion.a>

          <p className="mt-4 text-sm text-stone-400" data-id="element-141">
            Haz clic aquí para descargar tu guía al instante y transformar tu
            cena de hoy.
          </p>
        </motion.div>
      </div>
    </section>;
}